<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

// Edited: `as="span"` lets a skeleton sit inline, where a div would break the markup.
interface SkeletonProps {
  class?: HTMLAttributes["class"];
  as?: "div" | "span";
}

const props = withDefaults(defineProps<SkeletonProps>(), { as: "div" });
</script>

<template>
  <component
    :is="props.as"
    data-slot="skeleton"
    aria-hidden="true"
    :class="cn('animate-pulse rounded-md bg-primary/10', props.as === 'span' && 'inline-block', props.class)"
  />
</template>
